/*
 * Welme 商品ページ 購入UI
 * ------------------------------------------------------------
 * snippets/welme-buy-box.liquid が出力する設定(JSON)を読み取り、
 * 通常購入／定期購入・袋数の選択に応じて価格・割引率・注記・CTAを切り替える。
 *
 * 通常購入: /cart/add.js でカート追加 → /checkout へ直行（カート画面は経由しない）
 * 定期購入: /cart/add.js に selling_plan 付きで追加 → /checkout へ直行
 *           （BuyLinkのアプリプロキシ遷移は間欠的に空カートへ跳ねる不具合があるため、
 *            通常購入と同じファーストパーティAjaxに統一。失敗時のみ BuyLink にフォールバック）
 *
 * 割引は通常＝Shopify自動割引、定期＝Huckleberryプラン（selling_plan）割引で当たる。
 * selling_plan はネイティブのShopify定期プランのため、cart/add.js 経由でも
 * プランの価格調整（初回・継続）がチェックアウトでそのまま適用される。
 * このスクリプトは表示と遷移のみを担当し、基準価格は変更しない。
 */
(function () {
  function yen(value) {
    return '¥' + Number(value).toLocaleString('ja-JP');
  }

  function parseConfig(root) {
    const script = root.querySelector('.wb-config');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('[welme-buy-box] 設定の読み込みに失敗しました', error);
      return null;
    }
  }

  function initRoot(root) {
    if (root.dataset.welmeBuyInit === 'true') return;
    root.dataset.welmeBuyInit = 'true';

    const config = parseConfig(root);
    if (!config) return;

    const el = (selector) => root.querySelector(selector);

    let mode = 'normal';
    // 袋数: 1袋がない商品（MIX）は '2' 固定
    let bag = config.hasBags ? '1' : '2';

    // トップページ等から ?plan=subscription 付きで遷移してきた場合は
    // 購入方法トグルを「定期購入」で初期選択する（無ければ従来どおり通常購入）。
    try {
      if (new URLSearchParams(window.location.search).get('plan') === 'subscription') {
        mode = 'sub';
      }
    } catch (error) {
      /* URLSearchParams 非対応環境では従来どおり通常購入 */
    }

    function render() {
      const current = config[mode] && config[mode][bag];
      if (!current) return;

      el('.wb-current').textContent = yen(current.price);
      el('.wb-off').textContent = current.off || '';

      const compare = config.compareAt ? config.compareAt[bag] : null;
      const compareEl = el('.wb-compare');
      if (compare) {
        compareEl.textContent = yen(compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }

      const subnote = el('.wb-subnote');
      const cycleNote = el('.wb-cyclenote');
      const shakerNote = el('.wb-shaker-note');
      const cta = el('.wb-cta');

      if (mode === 'sub') {
        const contOff = current.contOff || '5%OFF';
        subnote.textContent =
          '初回価格（' + current.off + '）／2回目以降 ' + yen(current.cont) + '（' + contOff + '）';
        cycleNote.textContent = config.cycleNote || '';
        cta.textContent = '定期便を申し込む';
        if (shakerNote) shakerNote.hidden = false;
      } else {
        subnote.textContent = config.normalSubnote || '';
        cycleNote.textContent = '';
        cta.textContent = '購入する';
        if (shakerNote) shakerNote.hidden = true;
      }

      root.querySelectorAll('.wb-mode').forEach((button) => {
        button.classList.toggle('is-on', button.dataset.mode === mode);
      });
      root.querySelectorAll('.wb-bag').forEach((button) => {
        button.classList.toggle('is-on', button.dataset.bag === bag);
      });
    }

    root.querySelectorAll('.wb-mode').forEach((button) => {
      button.addEventListener('click', () => {
        mode = button.dataset.mode;
        render();
      });
    });

    root.querySelectorAll('.wb-bag').forEach((button) => {
      button.addEventListener('click', () => {
        bag = button.dataset.bag;
        render();
      });
    });

    let submitting = false;

    // カートを空にしてから対象商品を1点だけ追加し、購入画面へ直行する。
    // 毎回「選択した1点だけ」を確実にチェックアウトへ渡し、
    // 残存ラインによる空カートへの跳ね返り・商品の積み上がりを防ぐ。
    function checkoutWith(item, onFail) {
      return fetch('/cart/clear.js', { method: 'POST' })
        .then(() =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          })
        )
        .then((response) => {
          if (!response.ok) throw new Error('cart/add.js failed: ' + response.status);
          return response.json();
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch((error) => {
          console.error('[welme-buy-box] チェックアウト遷移に失敗しました', error);
          onFail();
        });
    }

    el('.wb-cta').addEventListener('click', () => {
      if (submitting) return;

      const cta = el('.wb-cta');

      if (mode === 'sub') {
        const data = config.sub[bag];
        const variant = data && data.variant;
        if (!variant) return;

        submitting = true;
        cta.disabled = true;

        const item = { id: variant, quantity: 1 };
        if (data.sellingPlan) item.selling_plan = data.sellingPlan;

        checkoutWith(item, () => {
          // Ajax追加が失敗した場合のみ、従来の BuyLink へフォールバック
          if (data.buylink) {
            window.location.href = data.buylink;
          } else {
            submitting = false;
            cta.disabled = false;
          }
        });
        return;
      }

      // 通常購入
      const variant = config.normal[bag] && config.normal[bag].variant;
      if (!variant) return;

      submitting = true;
      cta.disabled = true;

      checkoutWith({ id: variant, quantity: 1 }, () => {
        // フォールバック: カートページ経由
        window.location.href = '/cart/' + variant + ':1';
      });
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-welme-buy]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
